import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Link from '@mui/material/Link';
import Popover from '@mui/material/Popover';
import CheckIcon from '@mui/icons-material/Check';
import {
  bindPopover,
  usePopupState,
  bindTrigger,
} from 'material-ui-popup-state/hooks';
import Button from '@mui/material/Button';
import Timepicker, { formatMinutes } from 'components/form/TimePicker';
import toast from 'utils/toast';

const TimePopover = ({ value, onChange, isDefault }) => {
  const [time, setTime] = useState(value);
  const popupState = usePopupState({
    variant: 'popover',
    popupId: 'time-popover',
  });

  useEffect(() => {
    if (popupState.isOpen) {
      setTime(value);
    }
  }, [popupState.isOpen]);

  const onAccept = () => {
    try {
      onChange(time);
      popupState.close();
    } catch (e) {
      toast.error(e.message);
    }
  };

  return (
    <Box width={65} textAlign="center">
      <Link underline="always" href="#" {...bindTrigger(popupState)}>
        {value ? formatMinutes(value) : isDefault ? 'TIME' : '12:00AM'}
      </Link>
      <Popover
        {...bindPopover(popupState)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Stack direction="row" p={1} spacing={1} alignItems="center">
          <Timepicker margin="none" value={time} onChange={setTime} />
          <Button
            onClick={onAccept}
            sx={{ borderRadius: 30 }}
            startIcon={<CheckIcon />}
            variant="contained"
          >
            Accept
          </Button>
        </Stack>
      </Popover>
    </Box>
  );
};

export default TimePopover;
